module.exports = __webpack_public_path__ + "static/media/arrow_downward_24px.33d3144b.svg";